import { render } from "./MldPolicy.vue?vue&type=template&id=20e36506&scoped=true"
import script from "./MldPolicy.vue?vue&type=script&lang=js"
export * from "./MldPolicy.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MldPolicy.vue?vue&type=style&index=0&id=20e36506&lang=scss&module=s"
cssModules["s"] = style0
import "./MldPolicy.vue?vue&type=style&index=1&id=20e36506&lang=scss&scoped=true"
import "./MldPolicy.vue?vue&type=style&index=2&id=20e36506&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-20e36506"]])

export default __exports__